var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"circle-loader-wrapper"},[_c('div',{staticClass:"circle-loader",style:(_vm.loaderStyle)}),(!_vm.noTitle)?_vm._t("default",function(){return [_c('span',[_vm._v(_vm._s(_vm.$t('Загрузка')))])]}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }